var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"23967bdecdedc23231cbc9ae2501bca708020b63"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["linktracker@z5-internet-ltd"]={id:"23967bdecdedc23231cbc9ae2501bca708020b63"};
      